import { doodAtomConfig } from "./dood-atom-config";
import { propertyValue } from "../dood-block-config";

/**
 * `TabListAtom` declared through `doodAtomConfig`.
 *
 * Prefixed export: `composeTabListConfig` (derived from `TabListAtomComponent`).
 */
export const {
  composeTabListConfig,
  tabListAtomConfig,
  tabListAtomResolveConfig,
  tabListAtomProperties,
} = doodAtomConfig(
  {
    name: "Tab list",
    componentType: "TabListAtomComponent",
    sharedFields: {},
  },
  () => ({
    display_burger_navigation: propertyValue({
      type: "checkbox",
      value: false,
      options: { label: "pages.atoms.tab-list.display-burger-navigation.label" },
    }),
    padding_x: propertyValue({
      type: "checkbox",
      value: true,
      options: { label: "pages.atoms.tab-list.padding-x.label" },
    }),
    categories_background_color: propertyValue({
      type: "color",
      value: { type: "hex", value: "#FFFFFF" },
      options: { label: "pages.atoms.tab-list.categories-background-color.label" },
    }),
    categories_active_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-600" },
      options: { label: "pages.atoms.tab-list.categories-active-color.label" },
    }),
    categories_inactive_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "neutral-600" },
      options: { label: "pages.atoms.tab-list.categories-inactive-color.label" },
    }),
    burger_background_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-100" },
      options: { label: "pages.atoms.tab-list.burger-background-color.label" },
    }),
    burger_icon_color: propertyValue({
      type: "color",
      value: { type: "palette", value: "primary-600" },
      options: { label: "pages.atoms.tab-list.burger-icon-color.label" },
    }),
    secondary_categories_colors: {
      backgroundColor: propertyValue({
        type: "color",
        value: { type: "hex", value: "#FFFFFF" },
        options: {
          label: "pages.atoms.tab-list.secondary-categories-colors.background-color.label",
        },
      }),
      activeColor: propertyValue({
        type: "color",
        value: { type: "palette", value: "primary-600" },
        options: {
          label: "pages.atoms.tab-list.secondary-categories-colors.active-color.label",
        },
      }),
      inactiveColor: propertyValue({
        type: "color",
        value: { type: "palette", value: "neutral-600" },
        options: {
          label: "pages.atoms.tab-list.secondary-categories-colors.inactive-color.label",
        },
      }),
    },
    third_categories_colors: {
      backgroundColor: propertyValue({
        type: "color",
        value: { type: "hex", value: "#FFFFFF" },
        options: {
          label: "pages.atoms.tab-list.third-categories-colors.background-color.label",
        },
      }),
      activeColor: propertyValue({
        type: "color",
        value: { type: "palette", value: "primary-600" },
        options: {
          label: "pages.atoms.tab-list.third-categories-colors.active-color.label",
        },
      }),
      inactiveColor: propertyValue({
        type: "color",
        value: { type: "palette", value: "neutral-600" },
        options: {
          label: "pages.atoms.tab-list.third-categories-colors.inactive-color.label",
        },
      }),
    },
  }),
);

export type TabListAtomConfig = typeof tabListAtomConfig;
